import { CRM } from "@/components/atomic-crm/root/CRM";
import { B2B_PILOT_STAGES } from "@/components/atomic-crm/deals/funnels";

const taskTypes = [
  { value: "email", label: "Correo" },
  { value: "call", label: "Llamada" },
  { value: "meeting", label: "Reunión" },
  { value: "follow-up", label: "Seguimiento" },
  { value: "proposal", label: "Propuesta" },
  { value: "other", label: "Otro" },
];

const App = () => (
  <CRM
    title={import.meta.env.VITE_APP_NAME || "BaskervilleAI CRM"}
    lightModeLogo="/baskerville-favicon.png"
    darkModeLogo="/baskerville-favicon.png"
    dealStages={B2B_PILOT_STAGES}
    dealPipelineStatuses={["b2b_won"]}
    taskTypes={taskTypes}
    currency="USD"
    disableEmailPasswordAuthentication
    disableTelemetry
  />
);

export default App;
